$j(document).ready(function($) {
	$('.openVideoModal').on('click', function(e) {
		e.preventDefault();
		var video = $(this).data('video');
		$.ajax('/wp-content/themes/nysi/assets/video/load-video.php?v=' + video)
			.done(function(content) {
				$('#dentalVideoModal .loadContent').html(content);
				$('#dentalVideoModal #transcript').html('');
				$('#dentalVideoModal').foundation('open');
			})
	})
});